import type { ReactNode } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import styles from "./Section.module.scss";

export interface SectionProps {
  children: ReactNode;
  id?: string;
  className?: string;
}

export const Section = ({ children, id, className }: SectionProps) => {
  const [block, cn] = useModuleBEM(styles, "Section");

  return (
    <section id={id} className={clsx(className, block)}>
      <div className={cn("container")}>{children}</div>
    </section>
  );
};
